import moment from "moment";
import { ReactComponent as ViewIcon } from "../../../assets/images/view_eye_icon.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/images/icons/DownloadedIcon.svg";
import { convertBytesToReadableSize, getTitleCase } from "../../../utils/utilityFunctions/stringUtility";

import DeleteIcon from "../../../assets/images/icons/deleteIcon";
import DocumentIcon from "../../../utils/utilityFunctions/iconUtility";

const DocumentCard = ({ info, key, highlightText, searchText, handleOnDelete }) => {
  const handleViewAsset = () => {
    const link = info?.access_sas_link;
    if (link) {
      // Open the asset in a new tab
      window.open(link, "_blank");
    } else {
      console.warn("Asset link not available.");
    }
  };

  const handleDownloadAsset = () => {
    const link = info?.access_sas_link;
    if (link) {
      // Create a temporary anchor element to initiate download
      const anchor = document.createElement("a");
      anchor.href = link;
      anchor.download = ""; // Let the browser decide filename or use custom name like 'asset.pdf'
      document.body.appendChild(anchor);
      anchor.click();
      document.body.removeChild(anchor);
    } else {
      console.warn("Asset link not available.");
    }
  };

  return (
    <div key={key} className="flex gap-1">
      <div className="flex flex-row grow min-h-0 ">
        <div className="flex flex-col justify-between border-b border-[#D2DAE1] grow min-h-0 py-2 gap-2">
          <div className="flex  gap-2">
            <div className="p-1 flex">
              <div className="text-[#F8D775]">
                <DocumentIcon type={info?.type} filename={info?.display_name} />
              </div>
            </div>
            <div className="w-full flex flex-col gap-3">
              <div className="flex justify-between">
                <p className="text-md text-[#1D4469] font-medium flex gap-1 items-center">
                  {highlightText(
                    info?.display_name?.length > 25
                      ? getTitleCase(info?.display_name)?.slice(0, 25) + "..."
                      : getTitleCase(info?.display_name),
                    searchText
                  )}
                  <span className="text-[#38383899] text-sm">
                    {convertBytesToReadableSize({ bytes: Number(info?.size), unit: "auto" }) || "0 Bytes"}
                  </span>
                </p>

                <button onClick={() => handleOnDelete({ id: info?.id })} className="cursor-pointer opacity-80">
                  <DeleteIcon />
                </button>
              </div>
              <div className="flex justify-between text-xs text-[#38383899] font-normal">
                {highlightText(
                  `Uploaded By: ${getTitleCase(info?.created_by)} | ${moment(info?.created_at).format("DD MMM, YYYY, HH:mm")}`,
                  searchText
                )}
                <div className="flex items-center gap-3">
                  <ViewIcon onClick={handleViewAsset} className="cursor-pointer" />
                  <DownloadIcon onClick={handleDownloadAsset} className="cursor-pointer" />
                </div>
              </div>
            </div>
          </div>
          {/* </div> */}
        </div>
      </div>
    </div>
  );
};

export default DocumentCard;
